import { classNameTag } from '../../../utils/class-name-tag';
const dropdownTag = (...parts) => classNameTag('Dropdown', ...parts);
export const DropdownTags = {
    trigger: dropdownTag('trigger'),
    triggerText: dropdownTag('trigger', 'text'),
    item: dropdownTag('item'),
    itemText: dropdownTag('item', 'text'),
    label: dropdownTag('label'),
    errorText: dropdownTag('errorText'),
    scrollUpButton: dropdownTag('scrollUpButton'),
    scrollDownButton: dropdownTag('scrollDownButton'),
    separator: dropdownTag('separator'),
    sectionLabel: dropdownTag('sectionLabel'),
};
//# sourceMappingURL=class-name-tags.js.map